import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { ouvreCarteNationale } from './droitsCarte'
import { ROLE_CONSULTANT } from './etudes/consultant'
import { lienReconnexion } from './retourConnexion'

// requireAdmin=false → route "authentifié" (tout abonné connecté : /espace).
// requireAdmin=true  → route admin/direction uniquement (/admin).
// requireCarteNationale=true → admin OU titulaire du droit « carte nationale » (/sig, CDC G L1).
// requireEtudes=true → l'équipe OU un consultant (/etudes, ABS du 14/10) ; l'API revérifie.
// Avant : isAdmin était exigé partout → l'espace client était inaccessible aux clients.
export default function ProtectedRoute({
  children,
  requireAdmin = false,
  requireCarteNationale = false,
  requireEtudes = false,
}: {
  children: React.ReactNode
  requireAdmin?: boolean
  requireCarteNationale?: boolean
  requireEtudes?: boolean
}) {
  const { user, isAdmin, token, loading } = useAuth()
  const { pathname, search, hash } = useLocation()
  // SE-3 (CDC GBM du 27/10) : sans session (expirée page ouverte, ou jeton de la veille), la
  // connexion ramène à la page demandée.
  if (!token) return <Navigate to={lienReconnexion(pathname + search + hash)} replace />
  // /auth/me en vol (refresh, navigation directe) : attendre le rôle avant de juger,
  // sinon isAdmin=false transitoire → redirection à tort vers l'accueil.
  if (loading) return null
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />
  if (requireCarteNationale && !ouvreCarteNationale(user, isAdmin)) return <Navigate to="/" replace />
  if (requireEtudes && !isAdmin && user?.role !== ROLE_CONSULTANT) return <Navigate to="/" replace />
  return <>{children}</>
}
